// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HWlr5lNkYwab_3HM_PpF{margin-top:9px}.W4Karu1uVMkEVVHOzfFQ{background:var(--border-neutral-default);height:1px;margin:15.5px 0}.rjaqkfEIguEHctAlIEwm{display:block}.GpyNu2JsWl4FK5PHa5RX{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `HWlr5lNkYwab_3HM_PpF`,
	"divider": `W4Karu1uVMkEVVHOzfFQ`,
	"learnMorelink": `rjaqkfEIguEHctAlIEwm`,
	"trustScore": `GpyNu2JsWl4FK5PHa5RX`
};
export default ___CSS_LOADER_EXPORT___;
